import React from 'react';
import _ from "lodash";

import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import TextField from 'material-ui/TextField';

import {orange500} from 'material-ui/styles/colors';

const styles = {
    button: orange500,
};

class ExNames extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            anchorEl: null,
            exNameAdd: '',
        }

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.menuItems = this.menuItems.bind(this);
        this.removeVesselName = this.removeVesselName.bind(this);
        this.handleVesselAddNameField = this.handleVesselAddNameField.bind(this);
        this.handleVesselAddFormerName = this.handleVesselAddFormerName.bind(this);
    }

    handleOpen(e) {
        e.preventDefault();

        this.setState({
            open: true,
            anchorEl: e.currentTarget,
        });
    }

    handleClose() {
        this.setState({
            open: false,
        });
    }

    removeVesselName(index) {
        const exNames = _.cloneDeep(this.props.exNames);
        exNames.splice(index,1);
        this.props.changeField({
            field: 'exNames',
            value: exNames,
        });
    }

    handleVesselAddNameField(exNameAdd) {
        this.setState({
            exNameAdd,
        });
    }

    handleVesselAddFormerName(exName) {
        const exNames = _.cloneDeep(this.props.exNames);
        const { exNameAdd } = this.state;

        if(exNameAdd.trim()) {
            exNames.push({name: exNameAdd});

            this.props.changeField({
                field: 'exNames',
                value: exNames,
            });

            this.setState({
                exNameAdd: '',
            });

            this.menuItems(exNames);
        }
    }

    menuItems(exNames) {
        return exNames.map((exName, index) => (
          <MenuItem
            key={index}
            value={exName.name}
            primaryText={exName.name}
            rightIcon={
                <ContentRemoveIcon 
                    onClick={() => {
                        this.removeVesselName(index);
                    }}
                    color='red'
                />
            }
          />
        ));
      }

    render() {
        const { open, anchorEl, exNameAdd } = this.state;
        const { confirmed, getError, exNames, modifiedFields } = this.props;

        return (
            <React.Fragment>
                <div className='col-xs-3'>
                    <TextField 
                        disabled={confirmed}
                        name='exNameAdd'
                        value={exNameAdd}
                        errorText={getError('exNameAdd')}
                        onChange={(e, value) => {
                            this.handleVesselAddNameField(value);
                        }}
                        floatingLabelText='Former vessel name'
                        fullWidth
                    />
                </div>
                <div className='col-xs-1'>
                    <IconButton onClick={this.handleVesselAddFormerName} style={{ margin: '20px 0 0' }}>
                        <ContentAddIcon color='green' />
                    </IconButton>
                </div>
                <div className='col-xs-3' style={{ margin: '28px 0 0 0' }}>
                    <RaisedButton 
                        onClick={this.handleOpen}
                        label='Past names'
                        labelStyle={{ fontSize: '13px' }}
                        disabled={!exNames.length}
                        backgroundColor={modifiedFields && modifiedFields.includes('exNames') ? styles.button : null}
                    />
                    <Popover
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                        onRequestClose={this.handleClose}
                    >
                        <Menu>
                            {
                                this.menuItems(exNames)
                            }
                        </Menu>
                    </Popover>
                </div>
            </React.Fragment>
        );
    }
}

export default ExNames;


// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/ExNames.jsx